import React, { useEffect } from 'react';
import System from 'src/helper/system';
import { useBOMStore } from 'src/hooks/bom';
import BomListingHeader from './BomListing/BomListingHeader/BomListingHeader';
import BomTabsListing from './BomListing/BomTabsListing';
import useReduxState from "../../hooks/useReduxState";
import $ from "jquery";
import { isObject } from 'underscore';
import Constants from 'src/helper/Constants';
import ShowAlert from 'src/component/Global/ShowAlert';
import { useDOMAttachToSystemStore } from 'src/hooks/domAttachToSystem';
import HelperAnalyticsEvent from 'src/support/HelperAnalyticsEvent';

const isReRunPartMatch = System.getParams().isReRunPartMatch ? System.getParams().isReRunPartMatch : true;
const { storageName: { FLASH_MESSAGE, FLASH_MESSAGE_REMATCH, BOM_UPLOAD_FILE, BOM_RENAME } } = System

export function BomTabsList() {
    const [top] = useReduxState({}, 'BOM_DETAIL_TOP_PARAM_FOP_LIMIT', true);
    const [{ bom_detail_by_bom_id, bomSortByUpdatedDate, bom_detail_by_bom_id_type, bom_project_list }, { get_bom_detail_by_bom_id, get_bom_detail_by_bom_id_with_type }] = useBOMStore();
    const [{  }, {system_alert_indicator }, { }] = useDOMAttachToSystemStore();
    const { bomDetailPageTabs } = Constants
    const bomTabType = System.getParams().__c_BomTabList || bomDetailPageTabs.BomExactMatchTable.content;
    const bom_id = System.getParams().bomId

    useEffect(() => {
        async function fetchHere() {
            if (bom_id) {
                let c = System.getParams();
                delete c.go;
                history.pushState(null, null, '?' + $.param(c));
                let res = await get_bom_detail_by_bom_id({ bomId: bom_id })
                if (!res.payload || res.payload === null) {
                    window.history.back();
                    return;
                }
                if (localStorage.getItem(FLASH_MESSAGE)) {
                    system_alert_indicator({
                        name: 'FLASH_MESSAGE',
                        message: localStorage.getItem(FLASH_MESSAGE),
                        type: 'warning'
                    })
                    // Add New Local Storage for Rematch
                    localStorage.setItem(FLASH_MESSAGE_REMATCH, localStorage.getItem(FLASH_MESSAGE));
                    localStorage.removeItem(FLASH_MESSAGE);
                }
            } else {
                window.history.back()
            }
        }

        fetchHere()
    }, []);

    useEffect(() => {
        if (bom_detail_by_bom_id !== undefined && bom_detail_by_bom_id === null) {
            window.history.back()
        }
    }, [bom_detail_by_bom_id]);

    useEffect(() => {
        async function f() {
            let top_here = 10;
            if (top[bomDetailPageTabs[bomTabType].api_fetch_type] && top[bomDetailPageTabs[bomTabType].api_fetch_type].top) {
                top_here = top[bomDetailPageTabs[bomTabType].api_fetch_type].top;
            }
            top_here = top_here === 10 ? 20 : top_here;
            let param = {
                bomId: bom_id,
                isReRunPartMatch,
                matchType: bomDetailPageTabs[bomTabType].api_fetch_type,
                top: top_here
            }

            if (bomSortByUpdatedDate) {
                param.sortColumn = "updated_date"
                param.sortOrder = "desc"
            }
            let res = await get_bom_detail_by_bom_id_with_type(param);
            if (localStorage.getItem(BOM_UPLOAD_FILE)) {
                localStorage.removeItem(BOM_UPLOAD_FILE);
                let nothing_found_for_Exact_tab = false;
                try {
                    if (res.payload.data.Exact.count < 1) {
                        nothing_found_for_Exact_tab = true;
                    }
                } catch (e) {
                }

                if (localStorage.getItem(FLASH_MESSAGE_REMATCH) && nothing_found_for_Exact_tab === false) {
                    localStorage.removeItem(FLASH_MESSAGE_REMATCH);
                }
            }
        }
        if (top && isObject(top) && Object.keys(top).length > 0) {
            const { Exact: { top: exactTop }, Multiple: { top: multipleTop }, NoMatch: { top: nomatchTop } } = top;
            if (exactTop !== 20 || multipleTop !== 20 || nomatchTop !== 20) {
                f()
            }
        }
    }, [top]);

    useEffect(() => {
        if (Object.keys(bom_detail_by_bom_id)?.length && Object.keys(bom_detail_by_bom_id_type)?.length && 
        (localStorage.getItem(BOM_UPLOAD_FILE) || localStorage.getItem(BOM_RENAME))) {
            let projectName = '';
            if (bom_project_list && bom_detail_by_bom_id?.projectId) {
                projectName = bom_project_list[bom_detail_by_bom_id?.projectId]?.projectName;
            }
            let bomInfo = {
                bomId: bom_detail_by_bom_id?.bomId,
                bomTitle: bom_detail_by_bom_id?.bomName,
                bomProjectName: projectName,
                newBOM: (localStorage.getItem(BOM_UPLOAD_FILE) ? 'Yes' : bom_detail_by_bom_id?.newBOM),
                sourceOfBOM: localStorage.getItem(BOM_UPLOAD_FILE) ? 'upload' : bom_detail_by_bom_id?.source,
                exactMatchesReturned: bom_detail_by_bom_id_type?.Exact?.count,
                multipleMatchesReturned: bom_detail_by_bom_id_type?.Multiple?.count,
                noMatchesReturned: bom_detail_by_bom_id_type?.NoMatch?.count,
            }
            if (localStorage.getItem(BOM_UPLOAD_FILE)) {
                HelperAnalyticsEvent.bomFileUpload({ bomInfo });
                localStorage.removeItem(BOM_UPLOAD_FILE)
            }
            if (localStorage.getItem(BOM_RENAME)) {
                HelperAnalyticsEvent.bomRename({ bomInfo });
                localStorage.removeItem(BOM_RENAME)
            }
        }
    }, [bom_detail_by_bom_id, bom_detail_by_bom_id_type])

    return (

        <div className="logged-screen">
            <div>
                <div id="main">
                    {/* BOM-file-listing page */}
                    <div className="bom-copy">
                        <BomListingHeader isBomTab={true} />
                        <ShowAlert />
                        <BomTabsListing />
                    </div>
                </div>
            </div>
        </div>
    );

}
